@if (value) {
  <svg-icon
    class="size-5 text-green-600"
    src="assets/icons/General/check.svg"
  />
} @else {
  <svg-icon class="size-5 text-red-600" src="assets/icons/General/x.svg" />
}
